const bindings = {};

// TODO: use more powerful mock like requestAnimationFrame
bindings.batchedUpdates = (cb) => cb();
bindings.runAfterInteractions = (fn) => setTimeout(() => fn(), 50);

module.exports = bindings;
